import React, { SVGProps } from 'react';

export const History = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path
        d="M1.9 15C1.40294 15 1 14.5971 1 14.1C1 13.603 1.40294 13.2 1.9 13.2H3.31377C1.89305 11.9188 1 10.0637 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.4116 12.5594 14.2532 9.32891 14.874C9.25582 14.8932 9.1791 14.9034 9.1 14.9034C8.60294 14.9034 8.2 14.5004 8.2 14.0034C8.2 13.5601 8.52044 13.1917 8.94231 13.1172L8.94191 13.1149C11.3641 12.6717 13.2 10.5503 13.2 8C13.2 5.12812 10.8719 2.8 8 2.8C5.12812 2.8 2.8 5.12812 2.8 8C2.8 9.57199 3.49755 10.9811 4.6 11.9346L4.6 10.5C4.6 10.003 5.00295 9.60001 5.5 9.60001C5.99706 9.60001 6.4 10.003 6.4 10.5L6.4 14.1C6.4 14.5349 6.0915 14.8978 5.68138 14.9817C5.62279 14.9937 5.56213 15 5.5 15H1.9Z"
        fill="currentColor"
      />
      <path
        d="M8.00002 4.60156C8.49708 4.60156 8.90002 5.00451 8.90002 5.50156L8.90002 7.62687L10.3845 9.11133C10.7359 9.4628 10.7359 10.0326 10.3845 10.3841C10.033 10.7356 9.46316 10.7356 9.11169 10.3841L7.36363 8.63606C7.18458 8.45701 7.09674 8.22129 7.10012 7.98664L7.10002 7.97369L7.10002 5.50156C7.10002 5.00451 7.50297 4.60156 8.00002 4.60156Z"
        fill="currentColor"
      />
    </svg>
  );
};
